import BaseApi, { FetchMethodType } from 'api/BaseApi';
import AppHeaders from 'enums/AppHeaders';

export interface ICreateNewPasswordParams {
  password: string;
  resetPasswordToken: string;
}

export interface IResetPasswordParams {
  email: string;
  recaptchaToken?: string | null;
}

export interface IResetPasswordApi {
  resetPassword(params: IResetPasswordParams): void;
  createNewPassword(params: ICreateNewPasswordParams): void;
}

export default class ResetPasswordRestApi extends BaseApi implements IResetPasswordApi {
  public resetPassword({ email, recaptchaToken }: IResetPasswordParams) {
    return this.fetch('/reset-password', {
      method: FetchMethodType.POST,
      body: {
        email,
      },
      headers: new Headers({
        'Content-Type': 'application/json',
        ...(recaptchaToken ? { [AppHeaders.RecaptchaToken]: recaptchaToken } : {}),
      }),
    });
  };

  public createNewPassword({ password, resetPasswordToken }: ICreateNewPasswordParams) {
    return this.fetch(`/reset-password/${resetPasswordToken}`, {
      method: FetchMethodType.PUT,
      body: {
        password,
      },
    });
  };
}
